// We have to use direct import from the reducers (instead of using the Index file) to
// avoid circular dependencies with the action creators (who use these selectors)
import * as _notifSelectors from "./notification/reducer";
import * as _cartSelectors from "./cart/reducer";
import * as _shopSelectors from "./shop/reducer";
import * as _authSelectors from "./auth/reducer";
import * as _customerSelectors from "./customer/reducer";
import * as _adminOrderSelectors from "./adminOrder/reducer";
import * as _adminProductSelectors from "./adminProduct/reducer";

// Helper to wrap a redux selector with a predetermined state slice function
// https://gist.github.com/jslatts/1c5d4d46b6e5b0ac0e917fa3b6f7968f
const bindSelectors = (slicer, selectors) => {
  const keys = Object.keys(selectors);
  const boundMethods = {};

  keys.forEach((k) => {
    boundMethods[k] = (fullState) => selectors[k](slicer(fullState));
  });

  return boundMethods;
};


// ----------------- Selectors ------------------
// Partitioned according to state tree shape
export const notifSelectors = { ...bindSelectors((state) => state.notif, _notifSelectors) };
export const cartSelectors = { ...bindSelectors((state) => state.cart, _cartSelectors) };
export const shopSelectors = { ...bindSelectors((state) => state.shop, _shopSelectors) };
export const customerSelectors = { ...bindSelectors((state) => state.customer, _customerSelectors) };

export const authSelectors = { ...bindSelectors((state) => state.auth, _authSelectors) };
export const adminOrderSelectors = { ...bindSelectors((state) => state.adminOrder, _adminOrderSelectors) };
export const adminProductSelectors = { ...bindSelectors((state) => state.adminProduct, _adminProductSelectors) };
